import { configureStore, Middleware } from '@reduxjs/toolkit';
import reduxLogger from 'redux-logger';
import { sessionSlice } from './slices/session.slice';
import { loginSlice } from './slices/login.slice';
import { registrationSlice } from './slices/registration.slice';
import { environment } from '../environments/environment';
import { toastAdapter, toastSlice } from './slices/toast.slice';
import { sessionMiddleware, toastMiddleware } from './middleware';
import { profileImageSlice } from './slices/profile-image.slice';
import { emptySplitApi } from './slices/api.slice';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const rootReducer = {
    toast: toastSlice.reducer, // must statically define the key here, or else ts errors
    [sessionSlice.name]: sessionSlice.reducer,
    // auth slices
    [loginSlice.name]: loginSlice.reducer,
    [registrationSlice.name]: registrationSlice.reducer,
    // account slices
    [profileImageSlice.name]: profileImageSlice.reducer,
    // rtk-query
    [emptySplitApi.reducerPath]: emptySplitApi.reducer
};

/**
 * Create an initialised store for the app
 * @param preloadedState - merge this state into the initial state
 */
export const createAppStore = (preloadedState = {}) => {
    const middlewares: Middleware[] = [
        emptySplitApi.middleware,
        toastMiddleware.middleware,
        sessionMiddleware.middleware
    ];

    if ((environment as any).enableReduxLogger) {
        middlewares.push(reduxLogger);
    }

    return configureStore({
        preloadedState,
        middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewares),
        reducer: rootReducer
    });
};

export const store = createAppStore();

// @ts-ignore
window.store = store;

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
type DispatchFunc = () => AppDispatch;
export const useAppDispatch: DispatchFunc = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const toastSelectors = toastAdapter.getSelectors<RootState>(state => state.toast);
